import axios, { AxiosPromise } from 'axios';

const EMAILS_API = `${process.env.REACT_APP_API_URL}/api/emails`;

const axiosInstance = axios.create({
  baseURL: EMAILS_API,
  withCredentials: true
});

export interface StudioMigrationRequestPayload {
  unlimitedEmail: string;
  migrateFiles: boolean;
  migrateCredits: boolean;
  request: string;
  comments: string;
}

const studioMigrationRequest = (payload: StudioMigrationRequestPayload): AxiosPromise =>
  axiosInstance.post('/studio-migration', payload);

export default {
  studioMigrationRequest
};
